module.exports = __webpack_public_path__ + "images/cba0d64bde1a3dfc279024a19ce640d5.svg";